(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[959,594,329,721],{

/***/ 451:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/product-design",
      function () {
        return __webpack_require__(4020);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1594:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(714);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .title {\n    font-size: 50px;\n    text-transform: uppercase;\n    font-weight: 700;\n    margin: 0 0 30px 0;\n    height: auto;\n    width: 100%;\n    letter-spacing: 0.1em;\n\n    span {\n      display: block;\n      height: auto;\n      width: 100%;\n    }\n  }\n\n  .col {\n    width: 100%;\n  }\n\n  .content {\n    font-size: 18px;\n    font-weight: 500;\n    line-height: 1.5;\n    height: auto;\n    width: 100%;\n  }\n\n  @media screen and (min-width: ",
        ") {\n    width: 90%;\n    margin: 0 auto;\n    \n    .inner {\n      display: flex;\n      min-height: 28vw;\n      width: 100%;\n      box-sizing: border-box;\n    }\n    \n    .col {\n      box-sizing: border-box;\n      overflow: hidden;\n\n      &:first-child {\n        width: 60%;\n      }\n\n      &:last-child {\n        width: 40%;\n        min-height: 16.875vw;\n        padding-left: 10%;\n        padding-top: 160px;\n        padding-top: 11.11vw;\n      }\n    }\n\n    .title {\n      font-size: 100px;\n      font-size: 6.94vw;\n      line-height: 1.2;\n      margin: 0;\n    }\n\n    .content {\n      font-size: 1.25vw;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var ContentBlock = function(param) {
    var title = param.title, content = param.content, isPageTitle = param.isPageTitle;
    var renderHeader = function(isPageTitle, title) {
        if (isPageTitle) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
            className: "title",
            dangerouslySetInnerHTML: {
                __html: title
            }
        });
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
            dangerouslySetInnerHTML: {
                __html: title
            }
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ContentBlockWrap, {
        className: "".concat(isPageTitle ? "is-title" : " "),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
            className: "inner",
            children: [
                title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "col",
                    children: renderHeader(isPageTitle, title)
                }),
                content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                    className: "col",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "content",
                        dangerouslySetInnerHTML: {
                            __html: content
                        }
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ContentBlock);
var ContentBlockWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-5858fead-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakPoints.desktop;
});


/***/ }),

/***/ 5721:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(714);
/* harmony import */ var react_player__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2004);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _SliderWrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8251);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8494);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .content-item {\n    min-height: calc(90vw / 330 * 380);\n    position: relative;\n  }\n\n  .swiper-slide {\n    width: 90vw;\n  }\n\n  .player-wrapper {\n    width: auto; // Reset width\n    height: auto; // Reset height\n  }\n  .react-player {\n    padding-top: calc(90vw / 330 * 380); // Percentage ratio for 330:380\n    position: relative; // Set to relative\n  }\n\n  .react-player > div {\n    position: absolute; // Scaling will occur since parent is relative now\n    top: 0;\n    left: 0;\n  }\n\n  .sliderWrap__navigation {\n    display: none;\n  }\n\n  @media screen and (min-width: ",
        ") {\n    .content-item {\n      min-height: calc(90vw / 3 * 2);\n      position: relative;\n    }\n\n    .react-player {\n      padding-top: calc(90vw / 3 * 2); // Percentage ratio for 3:2\n    }\n  }\n\n  @media screen and (min-width: ",
        ") {\n    min-height: 50vh;\n\n    .sliderWrap__navigation {\n      display: block;\n      top: calc(50% - 17px);\n      left: calc(90vw - 47px);\n    }\n\n  }\n\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







var ContentSlider = function(param) {
    var contents = param.contents;
    // https://github.com/cookpete/react-player/issues/1428 : solve for Hydration failed
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), hasWindow = ref[0], setHasWindow = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        if (true) {
            setHasWindow(true);
        }
    }, []);
    var SlideImage = function(content) {
        if (content.media && content.media.data) {
            var _src = "".concat("https://studio-kast-cms.kliqs.ch").concat(content.media.data.attributes.url);
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "content-item",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_4___default()), {
                    src: _src,
                    layout: "fill",
                    alt: content.media.data.attributes.name,
                    objectFit: "cover",
                    // width={1366}
                    // height={856}
                    sizes: "100vw",
                    placeholder: "blur",
                    blurDataURL: "data:image/gif;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNk+A8AAQUBAScY42YAAAAASUVORK5CYII="
                })
            });
        }
    };
    var SlideVideo = function(content) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "content-item has-video",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "player-wrapper",
                children: hasWindow && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_player__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    className: "react-player",
                    width: "100%",
                    height: "100%",
                    url: "".concat(content.video_url)
                })
            })
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(ContentSliderComp, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "inner",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_SliderWrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                id: "content-slider",
                nav: true,
                initialSlide: 0,
                playSpeed: 2000,
                isFade: false,
                isAutoPlay: false,
                children: contents && contents.map(function(content, key) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_6__/* .SwiperSlide */ .o5, {
                        children: [
                            !content.is_video && SlideImage(content),
                            content.is_video && SlideVideo(content)
                        ]
                    }, key);
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ContentSlider);
var ContentSliderComp = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-a9d517ea-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakPoints.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.breakPoints.desktop;
});


/***/ }),

/***/ 1595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);



var SEO = function(param) {
    var title = param.title, description = param.description;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                    children: title ? title.replace(/(<([^>]+)>)/gi, "") : "StudioKast"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "description",
                    content: description ? description : ""
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:title",
                    content: title ? title.replace(/(<([^>]+)>)/gi, "") : ""
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:description",
                    content: description
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SEO);


/***/ }),

/***/ 3329:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(714);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 18px;\n  line-height: 24px;\n  font-weight: 500;\n\n  .inner {\n    box-sizing: border-box;\n  }\n\n\n  @media screen and (min-width: ",
        ") {\n\n    line-height: 1.6;\n    font-size: 1.25vw;\n    \n    .inner {\n      width: 90%;\n      margin-left: 8vw;\n      margin-right: 8vw;\n\n      p {\n        margin-top: 0;\n      }\n    }\n\n    .text-block {\n      column-count: 2;\n      column-gap: 60px;\n    }\n\n  }\n\n  @media screen and (min-width: ",
        ") {\n    .inner {\n      width: 70vw;;\n      margin-left: auto;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var TextBlock = function(param) {
    var contents = param.contents;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TextBlockWrap, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
            className: "inner",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "text-block",
                dangerouslySetInnerHTML: {
                    __html: contents
                }
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (TextBlock);
var TextBlockWrap = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-d32b2b1b-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.breakPoints.desktop;
}, function(param) {
    var theme = param.theme;
    return theme.breakPoints.wide;
});


/***/ }),

/***/ 4020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(714);
/* harmony import */ var _components_base_ContentBlock__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1594);
/* harmony import */ var _components_base_ContentSlider__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5721);
/* harmony import */ var _components_base_TextBlock__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3329);
/* harmony import */ var _components_layouts_Index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7972);
/* harmony import */ var _components_base_Seo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1595);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}







// import Image from 'next/image'
var ProductDesign = function(param) {
    var pageData = param.pageData, headerSlider = param.headerSlider;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_layouts_Index__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        heroSlider: headerSlider,
        children: [
            pageData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(PageWrap, {
                id: "content",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "section grid transition-all",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_base_ContentBlock__WEBPACK_IMPORTED_MODULE_2__["default"], {
                            title: pageData.title ? pageData.title : "",
                            content: pageData.lead_text ? pageData.lead_text : "",
                            isPageTitle: true
                        })
                    }),
                    pageData.slider && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "section",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_base_ContentSlider__WEBPACK_IMPORTED_MODULE_3__["default"], {
                            contents: pageData.slider
                        })
                    }),
                    pageData.content && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                        className: "section grid spacing",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_base_TextBlock__WEBPACK_IMPORTED_MODULE_4__["default"], {
                            contents: pageData.content
                        })
                    })
                ]
            }),
            pageData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_base_Seo__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                title: pageData.title,
                description: pageData.lead_text
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (ProductDesign);
var PageWrap = styled_components__WEBPACK_IMPORTED_MODULE_7__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-f4a2cb89-0"
})(_templateObject());


/***/ }),

/***/ 9008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5443)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,111,773,4,216,972,774,888,179], function() { return __webpack_exec__(451); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);